import { render, staticRenderFns } from "./ParentAddStory.vue?vue&type=template&id=b3231600&scoped=true&"
import script from "./ParentAddStory.vue?vue&type=script&lang=js&"
export * from "./ParentAddStory.vue?vue&type=script&lang=js&"
import style0 from "./ParentAddStory.vue?vue&type=style&index=0&id=b3231600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3231600",
  null
  
)

export default component.exports